import Link from 'components/link/Link.tsx'
import styles from './NoConnectionCard.module.scss'
import { useTranslation } from 'react-i18next'
import { routes } from 'types/routes.ts'
import { Card } from '@boltenergy-be/design-system'

const NoConnectionCard = () => {
  // i18n
  const { t } = useTranslation(['addresses'])

  return (
    <Card className={styles['no-connection']}>
      <small>{t(($) => $.overview.offtake.noGas)}</small>
      <Link href={routes.SUPPORT_CONTACT} variant="secondary">
        {t(($) => $.overview.offtake.contact)}
      </Link>
    </Card>
  )
}

export default NoConnectionCard
